/**
 * Superadmin check hook
 *
 * Uses API to verify superadmin status (source of truth is backend env var).
 */

import { useQuery } from "@tanstack/react-query";
import { api } from "../lib/api";

type SuperadminCheckResponse = {
  isSuperadmin: boolean;
};

/**
 * Check if current user is superadmin via API.
 * Only enabled when user is authenticated.
 */
export function useSuperadminCheck(enabled = true) {
  return useQuery({
    queryKey: ["user", "superadmin-check"],
    queryFn: async () => {
      const res = await api.user["superadmin-check"].$get();
      if (!res.ok) throw new Error("Failed to check superadmin status");
      return res.json() as Promise<SuperadminCheckResponse>;
    },
    enabled,
    staleTime: 5 * 60 * 1000, // Consider stale after 5 minutes
    gcTime: Infinity, // Never garbage collect - status doesn't change mid-session
    retry: false,
  });
}
